export class Alerta {
    id: number;
    asociado: number;
    fecha: string;
    descripcion: string;
    url: string;
    activo: string;


    constructor() {
        this.id = 0;
        this.asociado = 0;
        this.fecha = '';
        this.descripcion = '';
        this.url = '';
        this.activo = '';
    }
}